export default "__VITE_ASSET__0843GznQ__"